export default __webpack_public_path__ + "static/media/parmesan_cheese.88086662.png";